export function formatCPF(value: string): string {
  return value.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
}

export const phoneMask = (stringToMask: string) =>
  stringToMask
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})/, '$1-$2');

export const clearMask = (stringToClearMask: string) => stringToClearMask.replace(/\W/g, '');

export function formatWeight(weightString: string, hasSpace = true) {
  const regex = /^(\d+(\.\d+)?)(kg|ton)$/;
  const match = weightString.match(regex);

  if (!match) return null;

  const weight = parseFloat(match[1]);
  const unit = match[3];

  if (hasSpace) return `${weight} ${unit}`;

  return `${weight}${unit}`;
}
interface FormattedText {
  text: string;
  showTooltip: boolean;
}

export function formatTagText(text: string): FormattedText {
  if (text.length > 20) {
    const formattedText = text.substring(0, 17);
    return { text: `${formattedText}...`, showTooltip: true };
  }
  return { text, showTooltip: false };
}

export function abreviatedMonthToNumber(abreviatedMonth: string) {
  const months = {
    Jan: '01',
    Fev: '02',
    Mar: '03',
    Abr: '04',
    Mai: '05',
    Jun: '06',
    Jul: '07',
    Ago: '08',
    Set: '09',
    Out: '10',
    Nov: '11',
    Dez: '12',
  };

  const [monthAbrev, year] = abreviatedMonth.split('/');

  if (monthAbrev in months) {
    const monthNumber = months[monthAbrev as keyof typeof months];
    return `${monthNumber}/${year}`;
  }
  return abreviatedMonth;
}
